// extracted by mini-css-extract-plugin
export default {"reg_block":"RegBlock_reg_block__qNFbe","reg":"RegBlock_reg__TV-e7","enter":"RegBlock_enter__D7u+F"};